import React from 'react'
import { MyIcon } from '~/components/ui/MyIcon'
import { showMobile } from '~/utils'

export const Address: React.FC<{ orderData: any; isDarkMode?: boolean }> = ({
  orderData,
  isDarkMode,
}) => {
  return (
    <>
      <div
        className={`text-base font-semibold mb-1 break-all ${
          isDarkMode ? 'text-neutral-900' : 'text-neutral-100'
        }`}
      >
        <span>{orderData?.receiverInfo?.name}</span>
        <span className="ml-2">
          {showMobile(orderData?.receiverInfo?.phone)}
        </span>
      </div>
      <div
        className={`text-xs font-normal break-all ${
          isDarkMode ? 'text-neutral-900' : 'text-neutral-100'
        }`}
      >
        {orderData?.receiverInfo?.address}
      </div>
      <div className="absolute right-4 top-1/2 -translate-y-1/2 text-neutral-400">
        <MyIcon icon="arrow-right-simple" className="text-lg" />
      </div>
    </>
  )
}
